import Draw from "./Draw";
import Manual from "./Manual";
import Rectangle from "./Rectangle";

export default {
    Manual,
    Rectangle,
    Draw,
};
